import { render, staticRenderFns } from "./TimingBelt.vue?vue&type=template&id=bf9b90ba"
import script from "./TimingBelt.vue?vue&type=script&lang=js"
export * from "./TimingBelt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports